import {
  Breadcrumb,
  BreadcrumbItem,
  BreadcrumbLink,
  Container,
  Heading,
  Image,
  Tab,
  TabList,
  TabPanel,
  TabPanels,
  Tabs,
} from "@chakra-ui/react";
import { useState } from "react";
import { Link, useParams } from "react-router-dom";
import { browseTitleMap, urlMap } from "../../../core/constants";
import DCLogo from "../../../resources/images/dc_comics.svg";
import MarvelLogo from "../../../resources/images/marvel.svg";
import StarWarsLogo from "../../../resources/images/star_wars.svg";
import ImageLogo from "../../../resources/images/image.svg";
import BrowseList from "../components/BrowseList";

const BrowseOrders = () => {
  const [tabIndex, setTabIndex] = useState(0);
  const { category } = useParams();

  return (
    <Container maxW="container.lg">
      <Breadcrumb mt="6">
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="/browse">
            Browse
          </BreadcrumbLink>
        </BreadcrumbItem>
        <BreadcrumbItem>
          <BreadcrumbLink as={Link} to="#">
            {browseTitleMap[category]}
          </BreadcrumbLink>
        </BreadcrumbItem>
      </Breadcrumb>
      <Heading as="h2" mb="6">
        {browseTitleMap[category]}
      </Heading>
      <Tabs index={tabIndex} onChange={(index) => setTabIndex(index)} isLazy>
        <TabList>
          <Tab>
            <Image src={MarvelLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={DCLogo} height={30} />
          </Tab>
          <Tab>
            <Image src={StarWarsLogo} height={45} />
          </Tab>
          <Tab>
            <Image src={ImageLogo} height={29} />
          </Tab>
        </TabList>
        <TabPanels>
          <TabPanel>
            <BrowseList type={urlMap[category]} franchise={tabIndex + 1} />
          </TabPanel>
          <TabPanel>
            <BrowseList type={urlMap[category]} franchise={tabIndex + 1} />
          </TabPanel>
          <TabPanel>
            <BrowseList type={urlMap[category]} franchise={tabIndex + 1} />
          </TabPanel>
          <TabPanel>
            <BrowseList type={urlMap[category]} franchise={tabIndex + 1} />
          </TabPanel>
        </TabPanels>
      </Tabs>
    </Container>
  );
};

export default BrowseOrders;
